import script from "./UsersList.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersList.vue?vue&type=script&setup=true&lang=js"

import "./UsersList.vue?vue&type=style&index=0&id=666aaee8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-666aaee8"]])

export default __exports__